import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const SubCategoryPage = () => {
  const { subcategory } = useParams(); // e.g., Korvai
  const [sarees, setSarees] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("https://prsilks.com/proxy.php")
      .then((res) => res.json())
      .then((data) => {
        const filtered = data.filter(
          (item) =>
            item.subcategory && item.subcategory.toLowerCase() === subcategory.toLowerCase()
        );
        setSarees(filtered);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
        setSarees([]);
        setLoading(false);
      });
  }, [subcategory]);

  return (
    <div className="p-6 mt-20 2xl:mt-20 8xl:mt-28 10xl:mt-44 11xl:mt-56">
      <h2 className="text-center text-3xl font-bold mb-6 text-secondary">
        {subcategory} Sarees
      </h2>

     

      {loading ? (
        <p className="text-center font-sans font-semibold text-lg 4xl:text-xl 6xl:text-2xl text-secondary mt-10">
            Loading beautiful sarees... Just a moment!
          </p>
      ) : sarees.length === 0 ? (
        <p className="text-center">No sarees found in this category.</p>
      ) : (
         <div className="grid grid-cols-2 3xl:grid-cols-4 gap-4 8xl:gap-7">
            {sarees.map((item, index) => (
              <div
                key={index}
                className="rounded shadow-xl bg-[#fff] 8xl:rounded-lg 10xl:rounded-xl 11xl:rounded-2xl hover:zoom-in-100 hover:scale-105 transition-transform duration-300"
              >
                <img
                  src={item.url}
                  alt={item.subcategory}
                  className="p-1 lg:p-3 rounded-md md:rounded-lg xl:rounded-2xl 11xl:rounded-3xl w-full object-cover "
                  loading="lazy"
                />

                <div className="flex py-2 px-2 md:px-4 justify-between items-center font-bold text-[10px] md:text-[12px] xl:text-[14px] 3xl:text-[16px] ">
                  <p className="font-sans">{item.price}</p>
                  <a
                    href={`https://api.whatsapp.com/send?phone=919363799534&text=I%20am%20interested%20to%20buy%20your%20${encodeURIComponent(
                      `${item.name} ${item.url} ${item.price}`
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center border border-secondary bg-secondary text-primary rounded-full px-1 py-1  "
                  >
                    Buy now
                  </a>
                </div>
              </div>
            ))}
          </div>
      )}
    </div>
  );
};

export default SubCategoryPage;
